import { render, staticRenderFns } from "./myinfo-register-password-2.vue?vue&type=template&id=78c3abb9&"
import script from "./myinfo-register-password-2.vue?vue&type=script&lang=js&"
export * from "./myinfo-register-password-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports